export class ResourceTypes {
    public static readonly COMMON = "common";
    public static readonly MESSAGES = "messages";
}
